export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11274_WINNING_PERCENTAGE_EXPLANATION': 'Winning % Explanation'
};
